<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import CheckCircle from '../icons/CheckCircle.svelte';
  import ErrorIcon from '../icons/ErrorIcon.svelte';
  import { validateEmail } from '../../etc/utils';
  import Label from '../typography/Label.svelte';
  import Text from '../typography/Text.svelte';

  const dispatch = createEventDispatcher();

  export let label;
  export let name;
  export let type;
  export let placeholder;
  export let input = undefined;
  export let value;
  export let maxLength = undefined;
  export let inputmode = undefined;
  export let pattern = undefined;
  export let readonly = undefined;
  export let disabled = undefined;
  export let error = undefined;
  export let showCheckOnBlur = false;
  export let removeIconsTopOffset = false;

  let showCheckCircle = validateInput();

  function validateInput() {
    if (!showCheckOnBlur) return false;
    if (type === 'email') return validateEmail(value);
    return !!value;
  }

  function handleInput(e) {
    const newValue = type.match(/^(number|range)$/)
      ? +e.target.value
      : e.target.value;
    value = newValue;
    dispatch('input', newValue);
  }

  function onBlur() {
    dispatch('blur');

    if (showCheckOnBlur) {
      showCheckCircle = validateInput();
    }
  }
</script>

<label class="input" for={name}>
  <Label color="#7489B0" type="default-medium" class="input__label"
    >{label}</Label
  >
  <input
    bind:this={input}
    on:blur={onBlur}
    on:input={handleInput}
    class="input__field"
    class:input__field--error={error}
    id={name}
    {name}
    {placeholder}
    {value}
    {maxLength}
    {inputmode}
    {pattern}
    {type}
    {readonly}
    {disabled}
  />
  {#if !error}
    <div
      class="check-icon"
      style="margin-top: {label ? '13px' : !removeIconsTopOffset && '2px'}"
      class:active={showCheckCircle}
    >
      <CheckCircle />
    </div>
  {:else}
    <div
      class="check-icon"
      style="margin-top: {label ? '13px' : !removeIconsTopOffset && '2px'}"
      class:active={error}
    >
      <ErrorIcon />
    </div>
  {/if}
</label>
{#if error}
  <Text color="#FF1E62" type="small" class="input__error">{error}</Text>
{/if}

<style lang="scss">
  :global(.input__label) {
    font-size: 14px !important;
    line-height: 20px !important;
  }
  :global(.input__error) {
    font-size: 12px !important;
    line-height: 18px !important;
  }
  .input {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    position: relative;

    &__field {
      margin-top: 4px;
      border: 1px solid var(--twism-theme-slightBorder);
      border-radius: 4px;
      font-size: 14px;
      line-height: 22px;
      padding: 9px 28px 9px 8px;
      color: var(--twism-theme-typography);
      transition: border-color 0.2s ease-in-out;
      &::placeholder {
        color: $color-neutral-gray;
      }
      &:focus {
        border-color: var(--twism-theme-primary);
        outline: none !important;
      }

      &--error {
        border: 1.2px solid #ff1e62;
      }
    }

    .check-icon {
      height: 24px;
      position: absolute;
      right: 14px;
      top: 50%;
      transform: translateY(-50%);
      opacity: 0;
      pointer-events: none;
      transition: all 0.2s ease-in-out;

      &.active {
        opacity: 1;
      }
    }
  }
</style>
